export const DELETE_TEAM_FIRM_MUTATION = `
  mutation DeleteTeamFirm($id: Int!) {
    delete_team_firms_by_pk(id: $id) {
      id
    }
  }
`;

export const ASSIGN_FIRM_TO_TEAM_MUTATION = `
  mutation AssignFirmToTeam($teamId: Int!, $firmId: Int!, $companyId: Int!) {
    insert_team_firms_one(
      object: { team_id: $teamId, firm_id: $firmId, company_id: $companyId }
    ) {
      id
      team_id
      firm_id
      company_id
    }
  }
`;

export const REMOVE_FIRM_FROM_TEAM_MUTATION = `
  mutation RemoveFirmFromTeam($teamId: Int!, $firmId: Int!) {
    delete_team_firms(
      where: { team_id: { _eq: $teamId }, firm_id: { _eq: $firmId } }
    ) {
      affected_rows
    }
  }
`;
